export default __webpack_public_path__ + "94f4bd76d55b42b52b9a7e9c3b2fa50c.webp";